exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".will-load {\n  min-height: 80px; }\n\na[md-icon-button] {\n  line-height: 36px; }\n\n.text-capital {\n  text-transform: capitalize; }\n\ntd-layout-manage-list .mat-toolbar {\n  font-weight: 400; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/css-loader?{"sourceMap":false,"importLoaders":1}!/var/lib/jenkins/workspace/_storageApp.Front.release/~/postcss-loader?{"ident":"postcss"}!/var/lib/jenkins/workspace/_storageApp.Front.release/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/var/lib/jenkins/workspace/_storageApp.Front.release/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = 2